<template>

    <form @submit.prevent="$emit('submitted')">

        <slot name="form"></slot>

        <div v-if="hasActions">
            <slot name="actions"></slot>
        </div>

    </form>

</template>

<script>
    import { defineComponent } from 'vue'
    import JetSectionTitle from './SectionTitle.vue'

    export default defineComponent({
        emits: ['submitted'],

        components: {
            JetSectionTitle,
        },

        computed: {
            hasActions() {
                return !! this.$slots.actions
            }
        }
    })
</script>
